import { Button, ButtonProps } from 'decentraland-ui/dist/components/Button/Button'

import './InvertedButton.css'

export default function InvertedButton(props: ButtonProps) {
  return <Button className="InvertedButton" {...props} />
}
